import * as React from "react";
import * as styles from "./QuickJournalDuneDustParticles.css";

const particleClassNames = [
    styles.particleOne,
    styles.particleTwo,
    styles.particleThree,
    styles.particleFour,
    styles.particleFive,
    styles.particleSix,
    styles.particleSeven,
    styles.particleEight,
    styles.particleNine,
    styles.particleTen,
    styles.particleEleven,
    styles.particleTwelve,
    styles.particleThirteen,
    styles.particleFourteen,
    styles.particleFifteen,
];

export function QuickJournalDuneDustParticles({
    isPaused = false,
}: {
    isPaused?: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div aria-hidden="true" className={styles.container}>
            {particleClassNames.map((particleClassName) => (
                <span
                    key={particleClassName}
                    className={particleClassName}
                    style={{ animationPlayState }}
                />
            ))}
        </div>
    );
}
